import * as Yup from 'yup';
import helper from '../../../utils/helper';
import validation from '../../../utils/validation';

const mainValidationSchema = (isChangePwd) => {
  return Yup.object().shape({
    name: Yup.string().required('First name is required').nullable(),
    surname: Yup.string().required('Last name is required').nullable(),
    email: Yup.string().required('Email is required').nullable(),
    currentPassword: isChangePwd
      ? Yup.string().required('Password is required').nullable()
      : null,
    initials: Yup.string().required('Initials is required').nullable(),
    departmentId: Yup.string().required('Department is required'),
  });
};

export const validationSchema = (isChangePwd) => {
  if (isChangePwd) {
    return mainValidationSchema(isChangePwd).concat(
      helper.pwdValidationSchema({ containConfirm: true }),
    );
  } else return mainValidationSchema;
};
